var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3158 4.68449H10.3685V3.73712H11.3158V4.68449Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.894775 2.31607C0.894775 1.53125 1.531 0.89502 2.31583 0.89502H13.6842C14.4691 0.89502 15.1053 1.53125 15.1053 2.31607V13.6845C15.1053 13.6876 15.1053 13.6906 15.1053 13.6937C15.1003 14.4743 14.466 15.1055 13.6842 15.1055H2.31583C1.73327 15.1055 1.23258 14.755 1.0132 14.2533C1.00168 14.227 0.990942 14.2002 0.981005 14.1731C0.971208 14.1463 0.962194 14.1192 0.953988 14.0917C0.916271 13.9654 0.895648 13.8317 0.894802 13.6934C0.894784 13.6904 0.894775 13.6875 0.894775 13.6845V2.31607ZM14.1579 8.7458L11.7895 6.37892L8.98667 9.17993L5.15769 4.39682L1.84214 8.54396V2.31607C1.84214 2.05446 2.05422 1.84239 2.31583 1.84239H13.6842C13.9459 1.84239 14.1579 2.05446 14.1579 2.31607V8.7458Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e2d40321f06a1a9e82bf9d6faf856024.svg";
export { ForwardRef as ReactComponent };